import { firestore } from '../lib/db';
import { Timestamp, deleteField, collection, query, where, getDoc, doc, setDoc } from "firebase/firestore/lite";
import { getUUID, sampleChapterUUID } from '../lib/utils';
import { GET_AUTO_CHAPTERS_ACTION } from './types';

// ThunkAction<AppState> fetchAutoChapters(String guid) {
//     return (Store<AppState> store) async {
export const fetchAutoChapters = (uuid) => async (dispatch, getState) => {
    let chapterInfo = getState().autoChapters;
  let userDetails = getState().userDetails;
//   if((!userDetails || !userDetails.uid) && uuid != sampleChapterUUID) {
//     return;
//   }
  if (chapterInfo[uuid]) {
        return;
    }
    getDoc(doc(firestore, `autoChapters`, uuid)).then(doc => {
      if (doc.exists()) {
        const data = doc.data();
        // utils.printLog('fetchAutoChapters2: ' + guid);
        // // if (data['guid'] != null) {
        // utils.printLog('fetchAutoChapters3: ' + guid);
        // utils.printLog(data['chapters']);
        // store.dispatch(GetAutoChaptersAction(guid, data['chapters'] ?? []));
        dispatch({
            type: GET_AUTO_CHAPTERS_ACTION,
            uuid,
            payload: data['chapters'] || []
          });
        // }
      } else {
        // store.dispatch(GetAutoChaptersAction(guid, []));
        dispatch({
            type: GET_AUTO_CHAPTERS_ACTION,
            uuid,
            payload:[]
          });
      }
    });
}
  
//   class GetAutoChaptersHiddenAction {
//     final Map info;
//     final String guid;
//     GetAutoChaptersHiddenAction(this.guid, this.info);
//   }
  
//   class AddAutoChaptersHiddenAction {
//     final String chapterId;
//     final String guid;
//     AddAutoChaptersHiddenAction(this.guid, this.chapterId);
//   }
  
//   class DeleteAutoChaptersHiddenAction {
//     final String chapterId;
//     final String guid;
//     DeleteAutoChaptersHiddenAction(this.guid, this.chapterId);
//   }
  
//   String hiddenChaptersDocId(String userUID, String guid) {
//     return utils.getUUID(guid) + '_' + userUID;
//   }
  
//   ThunkAction<AppState> fetchAutoChaptersHidden(String guid) {
//     return (Store<AppState> store) async {
//       final Map userDetails = userDetailsStateSelector(store.state);
//       final Map? chaptersHiddenInfo =
//           autoChaptersHiddenSpecificSelector(store.state, guid);
//       if (chaptersHiddenInfo != null) {
//         return;
//       }
//       utils.printLog('fetchAutoChapters: ' + guid);
//       final QuerySnapshot snapshot = await FirebaseFirestore.instance
//           .collection('autoChaptersHidden')
//           .where('userID', isEqualTo: userDetails['uid'])
//           .where('guid', isEqualTo: guid)
//           .limit(1)
//           // .doc('$guid')
//           .get();
//       snapshot.docs.forEach((doc) {
//         if (doc.exists) {
//           final Map data = doc.data() as Map;
//           utils.printLog('fetchAutoChapters2: ' + guid);
//           if (data['guid'] != null) {
//             utils.printLog('fetchAutoChapters3: ' + guid);
//             utils.printLog(data['chapters']);
//             store.dispatch(GetAutoChaptersHiddenAction(guid, data['chapterIds']));
//           }
//         } else {
//           store.dispatch(GetAutoChaptersHiddenAction(guid, {}));
//         }
//       });
//     };
//   }
  
//   ThunkAction<AppState> addAutoChaptersHidden(String guid, String chapterId) {
//     return (Store<AppState> store) async {
//       final Map userDetails = userDetailsStateSelector(store.state);
//       store.dispatch(AddAutoChaptersHiddenAction(guid, chapterId));
//       FirebaseFirestore.instance
//           .collection('autoChaptersHidden')
//           .doc(hiddenChaptersDocId(userDetails['uid'], guid))
//           .set({
//         'guid': guid,
//         'userID': userDetails['uid'],
//         'chapterIds': {'$chapterId': true}
//       }, SetOptions(merge: true));
//     };
//   }
  
//   ThunkAction<AppState> deleteAutoChaptersHidden(String guid, String chapterId) {
//     return (Store<AppState> store) async {
//       final Map userDetails = userDetailsStateSelector(store.state);
  
//       final Map<String, dynamic> deleteInfo = {};
//       deleteInfo['${chapterId}'] = FieldValue.delete();
//       store.dispatch(DeleteAutoChaptersHiddenAction(guid, chapterId));
//       FirebaseFirestore.instance
//           .collection('autoChaptersHidden')
//           .doc(hiddenChaptersDocId(userDetails['uid'], guid))
//           .set({'guid': guid, 'chapterIds': deleteInfo}, SetOptions(merge: true));
//     };
//   }
  